__turbopack_context__.v({
  "card": "style-module-scss-module__f9bCKa__card",
  "cardContent": "style-module-scss-module__f9bCKa__cardContent",
  "cardExpirationDate": "style-module-scss-module__f9bCKa__cardExpirationDate",
  "cardName": "style-module-scss-module__f9bCKa__cardName",
  "cardTitleDate": "style-module-scss-module__f9bCKa__cardTitleDate",
  "card__last": "style-module-scss-module__f9bCKa__card__last",
  "container": "style-module-scss-module__f9bCKa__container",
  "name": "style-module-scss-module__f9bCKa__name",
  "placements": "style-module-scss-module__f9bCKa__placements",
  "price": "style-module-scss-module__f9bCKa__price",
  "tableRow": "style-module-scss-module__f9bCKa__tableRow",
  "tariff": "style-module-scss-module__f9bCKa__tariff",
});
